// frontend/src/pages/ResetPassword.jsx
import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import './Auth.css';
import fullLogo from '../assets/branding/abogados_quiroz_logo_exact.svg';

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    if (!token) {
      setError('Token de recuperación no encontrado');
    }
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage(null);
    setError(null);

    if (password !== confirmPassword) {
      setError('Las contraseñas no coinciden');
      setLoading(false);
      return;
    }

    if (password.length < 6) {
      setError('La contraseña debe tener al menos 6 caracteres');
      setLoading(false);
      return;
    }

    try {
      const response = await axios.post(`${window.__CRM_API__ || 'http://localhost:8000/api'}/auth/reset-password`, {
        token,
        nueva_password: password
      });
      
      setMessage(response.data.mensaje);
      setSuccess(true);
      
      setTimeout(() => {
        navigate('/login');
      }, 3000);
      
    } catch (err) {
      setError(err.response?.data?.detail || 'Error al restablecer la contraseña');
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div className="auth-container">
        <div className="auth-card">
          <div className="auth-header">
            <img className="auth-inline-logo" src={fullLogo} alt="Abogados Quiroz" />
            <h1>Token inválido</h1>
            <p>El enlace de recuperación no es válido</p>
            <p className="auth-link">
              <a href="/forgot-password">Solicitar nuevo enlace</a>
            </p>
          </div>
        </div>
      </div>
    );
  }

  if (success) {
    return (
      <div className="auth-container">
        <div className="auth-card">
          <div className="auth-header">
            <img className="auth-inline-logo" src={fullLogo} alt="Abogados Quiroz" />
            <h1>¡Contraseña actualizada!</h1>
            <p>{message}</p>
            <p style={{ color: '#7f8c8d', fontSize: '14px' }}>
              Serás redirigido al inicio de sesión...
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <img className="auth-inline-logo" src={fullLogo} alt="Abogados Quiroz" />
          <h1>Abogados Quiroz</h1>
          <p>Crear nueva contraseña</p>
        </div>

        <form onSubmit={handleSubmit} className="auth-form">
          {message && (
            <div className="auth-success">
              <span>✅</span> {message}
            </div>
          )}
          {error && (
            <div className="auth-error">
              <span>⚠️</span> {error}
            </div>
          )}

          <div className="form-group">
            <label>Nueva contraseña</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Mínimo 6 caracteres"
              required
            />
          </div>

          <div className="form-group">
            <label>Confirmar contraseña</label>
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="Repite tu contraseña"
              required
            />
          </div>

          <button type="submit" className="btn-auth" disabled={loading}>
            {loading ? 'Actualizando...' : 'Actualizar contraseña'}
          </button>

          <p className="auth-link">
            <a href="/login">← Volver al inicio de sesión</a>
          </p>
        </form>
      </div>
    </div>
  );
};

export default ResetPassword;
